import Icon from '../components/Icon.vue'

Icon.register({
  sync: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M440.9 12.6L444.9 95.3C399.4 41.9 331.7 8 256 8 134.8 8 33.9 94.9 12.3 209.8 10.9 217.2 16.6 224 24.1 224H73.2C78.8 224 83.6 220.2 84.9 214.7 103.4 137.4 172.9 80 256 80 316.9 80 370.5 110.9 402.1 157.8L300.6 152.9C293.7 152.6 288 158.1 288 164.9V212.3C288 219 293.4 224.3 300 224.3H500.3C507 224.3 512.3 219 512.3 212.3V12C512.3 5.4 507 0 500.3 0H452.9C446.1 0 440.6 5.7 440.9 12.6zM256 432C195.1 432 141.5 401.1 109.9 354.2L211.8 359.1C218.6 359.4 224.3 353.9 224.3 347.1V299.7C224.3 293 219 287.7 212.3 287.7H12C5.4 287.7 0 293 0 299.7V500C0 506.6 5.4 512 12 512H59.4C66.2 512 71.7 506.3 71.4 499.4L67.2 416.8C112.7 470.2 180.4 504 256 504 377.2 504 478.1 417.1 499.7 302.2 501.1 294.8 495.4 288 487.9 288H438.8C433.2 288 428.4 291.8 427.1 297.3 408.6 374.6 339.1 432 256 432z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/sync.js
// module id = SRX1
// module chunks = 144